import { PAYMENT_TYPE_CHECKBOX, ACCOUND_DETAILS } from '../../utils/constants';
const soleBusinessType = 'SOLE TRADER';

export const isSoleBusinessType = state => {
  if (!state.dataCapture.get('businessTypeField')) {
    return false;
  }

  return state.dataCapture.get('businessTypeField').toUpperCase() === soleBusinessType;
};

/**
 * To return data on basis of key
 * @param {object} state
 * @param {string} key
 */
export const getBusinessData = (state, key) => {
  const data = state.dataCapture.toJS();
  return data[key];
};

export const getCustomerData = state => {
  if (!state.dataCapture) {
    return false;
  }
  return state.dataCapture.toJS();
};

export const getAccountDetails = state => {
  if (!state.dataCapture.get('account_details')) {
    return false;
  }
  return state.dataCapture.get('account_details').toJS();
};

export const getAboutBusinessData = state => {
  const busnessData = state.dataCapture.toJS();
  return busnessData[ACCOUND_DETAILS];
};

export const getPayementTypeSelection = (state, checkBoxValue) => {
  const paymentype = state.dataCapture.get('paymentOfType');
  return paymentype && paymentype.includes(value => value === checkBoxValue);
};

export const getPaymentTypeCheckboxValue = state => {
  return state.dataCapture.get(PAYMENT_TYPE_CHECKBOX);
};

export const getSubtype = state => {
  const caseData = state.dataCapture.get('caseData');
  return caseData && caseData.case_subtype;
};

export const getProductType = state => {
  const caseData = state && state.dataCapture ? state.dataCapture.get('caseData') : '';
  return caseData && caseData.product && caseData.product.type ? caseData.product.type : '';
};
export const showLoader = state => {
  const showLoader = state && state.dataCapture ? state.dataCapture.get('showLoader') : '';
  return showLoader && showLoader;
};
export const displayLoadingScreen = state => {
  return state && state.dataCapture ? state.dataCapture.get('showLoadingScreen') : false;
};

export const isCaseDataFetch = state => {
  const caseData = state.dataCapture.get('caseData');
  return !!caseData;
};
